/* ------------------------------------------------------------------
  File: index.jsx
  Author: Engr. Shaffa K. Kokro Jr. - CEO, Accend Holdings Ltd.
  Last Modified: 2026-05-10
------------------------------------------------------------------ */

// Purpose:
//   - MainLayout defines the primary website layout shell.
//   - It wraps all routed pages with shared global interface elements
//     such as the header, footer, and optional utility components.

import Header from "../Header";
import Footer from "../Footer";
import BackToTop from "../../common/BackToTop";
import { appConfig } from "../../../../app/config/appConfig";
import "./MainLayout.css";

const MainLayout = ({ children }) => {
  return (
    <div className="main-layout">
      <Header />
      <main 
        className="main-layout__content"
      >
        {children}
      </main>
      <Footer />
      {appConfig.navigation.showBackToTop && <BackToTop />}
    </div>
  );
};

export default MainLayout;